import { useCallback } from 'react';
import { stickyBannerHeightDesktop } from '@/vdp/StickyBanner/BannerStyles';
import { useIsMobile } from '~/context/common/DeviceContext';
import { desktopNavHeight } from './constants';
import { useGetMobileStickyBannerHeight } from '../StickyBanner/hooks';

const useGetElementOffsetTop = () => {
  const stickyBannerHeightMobile = useGetMobileStickyBannerHeight();
  const isMobile = useIsMobile();
  const height = isMobile
    ? stickyBannerHeightMobile
    : stickyBannerHeightDesktop;

  return useCallback(
    (elem: HTMLElement) =>
      elem.getBoundingClientRect().top +
      window.scrollY -
      desktopNavHeight -
      height,
    [height]
  );
};

export default useGetElementOffsetTop;
